// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SmileOutlinedSvg from "@fishx/icons-svg/es/asn/SmileOutlined";
import FishxIcon from '../components/FishxIcon';

var SmileOutlined = function SmileOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SmileOutlinedSvg
  }));
};

SmileOutlined.displayName = 'SmileOutlined';
export default React.forwardRef(SmileOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SmileOutlined.js
// module id = 4160
// module chunks = 0